/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
document.addEventListener("DOMContentLoaded", function () {
    // Hacer que collection__nav se quede fijo debajo del header
    var collectionNav = document.querySelector('.collection__nav');
    var themeHeader = document.querySelector('.theme__header');
    var headerWrapper = document.querySelector('[data-header-wrapper]') || document.querySelector('.header-sections');
    
    if (collectionNav && themeHeader) {
      var navOriginalTop = 0;
      var isNavFixed = false;
      var navHeight = 0;
      
      function calculateNavOriginalTop() {
        if (collectionNav) {
          var rect = collectionNav.getBoundingClientRect();
          navOriginalTop = rect.top + window.pageYOffset;
          navHeight = collectionNav.offsetHeight;
        }
      }
      
      function updateCollectionNavPosition() {
        if (!collectionNav) return;
        
        var headerHeight = 0;
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        // Calcular la altura del header
        if (headerWrapper) {
          headerHeight = headerWrapper.offsetHeight;
        } else if (themeHeader) {
          headerHeight = themeHeader.offsetHeight;
        }
        
        // Usar la variable CSS como respaldo
        var headerHeightCSS = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        if (headerHeightCSS && headerHeightCSS.trim() !== '') {
          var cssHeight = parseInt(headerHeightCSS);
          if (!isNaN(cssHeight) && cssHeight > 0) {
            headerHeight = cssHeight;
          }
        }
        
        // Si no tenemos altura, usar un valor por defecto
        if (headerHeight === 0) {
          headerHeight = 80;
        }
        
        // Calcular la posición original si no la tenemos
        if (navOriginalTop === 0) {
          calculateNavOriginalTop();
        }
        
        // Si el scroll ha pasado la posición original del nav menos la altura del header, hacerlo fixed
        var threshold = navOriginalTop - headerHeight;
        
        if (scrollTop >= threshold) {
          if (!isNavFixed) {
            isNavFixed = true;
            collectionNav.style.position = 'fixed';
            collectionNav.style.top = headerHeight + 'px';
            collectionNav.style.left = '0';
            collectionNav.style.right = '0';
            collectionNav.style.width = '100%';
            collectionNav.style.zIndex = '100';
            
            // Obtener el color de fondo
            var bgColor = getComputedStyle(collectionNav).backgroundColor;
            if (!bgColor || bgColor === 'rgba(0, 0, 0, 0)' || bgColor === 'transparent') {
              bgColor = getComputedStyle(document.body).getPropertyValue('--COLOR-BG') || '#ffffff';
            }
            collectionNav.style.backgroundColor = bgColor;
          } else {
            // Actualizar el top si el header cambia de tamaño
            collectionNav.style.top = headerHeight + 'px';
          }
        } else {
          if (isNavFixed) {
            isNavFixed = false;
            collectionNav.style.position = '';
            collectionNav.style.top = '';
            collectionNav.style.left = '';
            collectionNav.style.right = '';
            collectionNav.style.width = '';
            collectionNav.style.zIndex = '';
          }
        }
      }
      
      // Actualizar en scroll y resize
      var scrollHandler = function() {
        updateCollectionNavPosition();
      };
      var resizeHandler = function() {
        calculateNavOriginalTop();
        updateCollectionNavPosition();
      };
      
      window.addEventListener('scroll', scrollHandler, { passive: true });
      window.addEventListener('resize', resizeHandler);
      
      // Observar cambios en el header (por si cambia de tamaño)
      if (themeHeader) {
        var headerObserver = new MutationObserver(function() {
          updateCollectionNavPosition();
        });
        
        headerObserver.observe(themeHeader, {
          attributes: true,
          attributeFilter: ['class', 'style'],
          childList: false,
          subtree: false
        });
      }
      
      // Ejecutar varias veces para asegurar que se aplique
      setTimeout(function() {
        calculateNavOriginalTop();
        updateCollectionNavPosition();
      }, 100);
      setTimeout(function() {
        calculateNavOriginalTop();
        updateCollectionNavPosition();
      }, 300);
      setTimeout(function() {
        calculateNavOriginalTop();
        updateCollectionNavPosition();
      }, 500);
      setTimeout(function() {
        calculateNavOriginalTop();
        updateCollectionNavPosition();
      }, 1000);
    }
});

// Establecer el atributo 'channel' en el carrito automáticamente
document.addEventListener("DOMContentLoaded", function () {
  // Solo establecer el atributo si el carrito tiene items
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Verificar si el atributo 'channel' ya existe
      if (!cart.attributes || !cart.attributes.channel) {
        // Establecer el atributo 'channel' en el carrito
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              channel: 'online_store'
            }
          })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Cart attribute "channel" set to "online_store"');
        })
        .catch(error => {
          console.error('Error setting cart attribute:', error);
        });
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
});


  



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
